import React from "react";

import { useRetrievePersonalTimeSheet } from "@planzone/view-models";
import { usePreferences } from "@components/preferences";
import { Flag } from "@common/infiniteScroll";
import { TreeToggle, useUtils } from "@common/treeToggle";
import { Root } from "../root";
import { Total } from "../total";
import { Loader } from "../loader";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceLoader({
  resourceUuid,
  isLoading,
}: {
  resourceUuid: string;
  isLoading: boolean;
}) {
  const { isOpen } = useUtils();
  return isOpen(resourceUuid) && isLoading ? <Loader /> : null;
}

function TeamAllocations({
  resource,
  week,
  filters,
  showCompletionColumn,
}: Props) {
  const { state } = usePreferences();

  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    canLoadMore,
    currentPage,
    timeSheet,
    retrievePersonalTimeSheet,
    isDirty,
  } = useRetrievePersonalTimeSheet(resource, filters, 30);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrievePersonalTimeSheet({
        resource,
        filter: filters,
        page: 0,
        size: 30,
      });
  }, []);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestFailure &&
      isDirty &&
      retrievePersonalTimeSheet({
        resource,
        filter: filters,
        page: 0,
        size: Math.max(timeSheet.projects.length, 30),
      });
  }, [isDirty, isRequestPending]);

  return (
    <TreeToggle>
      <div className={styles.teamAllocations}>
        <Root
          timeSheet={timeSheet}
          filter={filters}
          areDetailsDisplayed={!state.isTimeSheetMinimized}
          showDeactivatedProjects={!state.showDeactivatedProjectsOnTimeSheets}
          isReloading={isDirty && isRequestPending}
          showCompletionColumn={showCompletionColumn}
          isOpenByDefault={false}
          showControls
        />
        <ResourceLoader
          resourceUuid={resource.uuid}
          isLoading={isRequestPending && !isDirty}
        />
        <Flag
          name={resource.uuid}
          isDisabled={isRequestPending || !canLoadMore}
          retrieveItems={() =>
            retrievePersonalTimeSheet({
              resource,
              filter: filters,
              size: 30,
              page: currentPage,
            })
          }
        />
        <div className={styles.footer}>
          <Total
            dates={week}
            timeSheet={timeSheet}
            areDetailsDisplayed={!state.isTimeSheetMinimized}
            resource={resource}
            isTeam
          />
        </div>
      </div>
    </TreeToggle>
  );
}

export { TeamAllocations };
